import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import CommonModal from '../../atoms/modal/CommonModal'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { formatCommonAmount } from '../../../util/formatAmount'
import styles from './AddAddOnModal.module.scss'

function AddAddOnModal({ open, onClose, parentPackage, onSelect, onCustom }) {
	const reduxPackages = useSelector((state) => state.packages?.packages) || []
	const availableAddOns = useMemo(() => {
		if (!parentPackage?.id) return []
		const pkg = reduxPackages.find((p) => p._id === parentPackage.id)
		return pkg?.addOnsIds || []
	}, [parentPackage?.id, reduxPackages])

	const handleSelectAddOn = (addon) => {
		onSelect({
			rowId: `addon_${parentPackage.rowId}_${addon._id}_${Date.now()}`,
			id: addon._id,
			name: addon.name ?? '',
			quantity: 1,
			unitPrice: parseFloat(addon.price) || 0,
			type: 'addOn',
		})
		onClose()
	}

	return (
		<CommonModal
			open={open}
			handleClose={onClose}
			heading="Add Add-on"
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						size="lg"
						onClick={onCustom}
					>
						Add custom add-on
					</ButtonCustom>
				</>
			}
		>
			<div className={styles.addAddOnModal}>
				{parentPackage && (
					<p className={styles.parentName}>
						Package: {parentPackage.name}
					</p>
				)}
				{availableAddOns.length > 0 ? (
					<ul className={styles.addOnList}>
						{availableAddOns.map((addon) => (
							<li key={addon._id} className={styles.addOnItem}>
								<button
									type="button"
									className={styles.addOnButton}
									onClick={() => handleSelectAddOn(addon)}
								>
									<span className={styles.addOnName}>
										{addon.name ?? '--'}
									</span>
									<span className={styles.addOnPrice}>
										{formatCommonAmount(addon?.price)}
									</span>
								</button>
							</li>
						))}
					</ul>
				) : (
					<p className={styles.noAddOns}>
						No add-ons defined for this package. Use &quot;Add
						custom add-on&quot; below.
					</p>
				)}
			</div>
		</CommonModal>
	)
}

export default AddAddOnModal
